<template>
	<div class="m-3 fill-height-container payment-methods-root">
		<LoadingIndicator v-if="isDataLoading" :message="progressText" class="center-absolute"/>

		<!--			"key" is needed for animation-->
		<div v-if="paymentIntegrationsData">
			<div v-if="detailsView" key="1">

				<component :is="detailsView"
						   :paymentIntegrationItem="paymentIntegrationItem"
						   :analytics-props="this.analyticsPropsMethod()"
						   @onSave="onIntegrationSave"
						   @onBackClicked="onDetailsBackClicked"/>
			</div>
			<div v-else key="2">

				<div class="title mb-4" v-if="!hideTitle">Available Payment integrations</div>
				<div class="mb-3" v-if="isCardPaymentIntegratedIgnoreDisabled">
					Credit/Debit card payments <qw-switch class="ml-2" v-model="paymentIntegrationsData.isCardPaymentEnabled" @change="enableCardPaymentsChanged"></qw-switch>
				</div>
				<div class="card p-4">
<!--					<qw-radio-group v-model="paymentIntegrationsData.creditCardMethod"-->
<!--									 @change="onCreditCardMethodChanged">-->

<!--						<qw-radio-->
<!--							label="STRIPE"-->
<!--							class="disabled-keep-text-color disabled-hide-radio w-100"-->
<!--							:class="{'hide-radio': true}"-->
<!--							:disabled="!isStripeIntegrated || !isCardPaymentEnabled">-->

<!--							<PaymentMethodRow-->
<!--								title="Stripe"-->
<!--								:disabled="!isCardPaymentEnabled"-->
<!--								:iconSrc="require('@/assets/images/ic_stripe.jpg')"-->
<!--								:buttonTitle="isStripeIntegrated ? 'View' : 'Connect'"-->
<!--								:loading="isStripeButtonLoading"-->
<!--								description="Qwoach has partnered with Stripe to provide you an automated way to collect credit card payments."-->
<!--								@onButtonClicked="stripeConnectClicked"-->
<!--							/>-->
<!--						</qw-radio>-->

<!--						<hr v-if="userProfile.cloverEnabled" />-->
<!--						<qw-radio v-if="userProfile.cloverEnabled" label="CLOVER" class="disabled-keep-text-color disabled-hide-radio w-100" :disabled="!isCloverIntegrated || !isCardPaymentEnabled">-->

<!--							<PaymentMethodRow-->
<!--								title="Clover"-->
<!--								:disabled="!isCardPaymentEnabled"-->
<!--								:iconSrc="require('@/assets/images/ic_clover.jpeg')"-->
<!--								:buttonTitle="isCloverIntegrated ? 'View' : 'Connect'"-->
<!--								:loading="isCloverButtonLoading"-->
<!--								description="Qwoach has partnered with Clover for online payments so you can easily collect them from your clients."-->
<!--								@onButtonClicked="cloverConnectClicked"-->
<!--							/>-->
<!--						</qw-radio>-->
<!--					</qw-radio-group>-->
					<PaymentMethodRow
						title="Stripe"
						:disabled="!isCardPaymentEnabled"
						:iconSrc="require('@/assets/images/ic_stripe.jpg')"
						:buttonTitle="isStripeIntegrated ? 'View' : 'Connect'"
						:loading="isStripeButtonLoading"
						description="Qwoach has partnered with Stripe to provide you an automated way to collect credit card payments."
						@onButtonClicked="stripeConnectClicked"
					/>


				</div>
				<div class="mt-4"></div>
				<div class="mb-3" v-if="isPayPalIntegrated">
					PayPal payments <qw-switch class="ml-2" v-model="paymentIntegrationsData.isPayPalPaymentEnabled" @change="enablePayPalPaymentsChanged"></qw-switch>
				</div>

				<div class="card p-4">

					<PaymentMethodRow
						title="PayPal"
						style="margin-left: 23px !important;"
						:disabled="!isPayPalPaymentEnabled"
						:iconSrc="require('@/assets/images/ic_paypal.png')"
						:buttonTitle="isPayPalIntegrated ? 'View' : 'Connect'"
						description="Integrate your PayPal account and allow your clients to pay using PayPal."
						@onButtonClicked="payPalConnectClicked"
					/>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import PaymentMethodRow from "@/core/modules/coach/Billing/view/PaymentIntegrations/PaymentMethodRow.vue";
import PayPalPaymentIntegration
	from "@/core/modules/coach/Billing/view/PaymentIntegrations/Options/PayPalPaymentIntegration.vue";
import StripePaymentIntegration
	from "@/core/modules/coach/Billing/view/PaymentIntegrations/Options/StripePaymentIntegration.vue";
import PaymentIntegrations from "@shared/Billing/PaymentIntegrations";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";

import BasePaymentMethodsView
	from "@/core/modules/coach/Billing/view/PaymentIntegrations/BasePaymentMethodsView.vue";
import IntegrationStatus from "@shared/Billing/IntegrationStatus";
import CloverPaymentIntegration
	from "@/core/modules/coach/Billing/view/PaymentIntegrations/Options/CloverPaymentIntegration.vue";
import {yesNoDialog} from "@/core/components/Dialogs/dialog";

export default {
	extends: BasePaymentMethodsView,
	name: "PaymentMethodsView",
	components: {
		CloverPaymentIntegration,
		LoadingIndicator, PayPalPaymentIntegration, StripePaymentIntegration, PaymentMethodRow
	},

	props: {
		paymentIntegrations: PaymentIntegrations,
		hideTitle: Boolean
	},

	watch: {
		paymentIntegrations: {
			immediate: true,
			handler() {
				this.paymentIntegrationsData = this.paymentIntegrations
			}
		}
	},

	data: () => ({
		paymentIntegrationsData: null,
		detailsView: null,
		payPalComponentName: "PayPalPaymentIntegration",
		stripeComponentName: "StripePaymentIntegration",
		cloverComponentName: "CloverPaymentIntegration",
		transitionName: "slide",
		paymentIntegrationItem: null,
		isStripeButtonLoading: false,
		isCloverButtonLoading: false,
	}),

	mounted() {
		this.setup()
	},
	methods: {

		async setup() {
			console.log("PaymentMethodsView: setup: this.paymentIntegrations = ", this.paymentIntegrations)
			if (!this.paymentIntegrations) {
				this.progressDataLoading()
				try {
					this.paymentIntegrationsData = await this.$dataManager.getPaymentIntegrationsMain()
				} catch (error) {
					this.handleError(error)
				}
				this.hideProgress()
			}
			await this.syncUserProfileIntegration()
		},

		getIntegrationsStatusFromBoolean(b){
			return b ? IntegrationStatus.INTEGRATED : IntegrationStatus.DETACHED
		},

		async syncUserProfileIntegration() {
			let isIntegrationSynced = false
			if (this.paymentIntegrationsData.isPayPalIntegrated() !== this.userProfile.integrationsList.isPayPalIntegrated()) {
				let integrationStatus = this.getIntegrationsStatusFromBoolean(this.paymentIntegrationsData.isPayPalIntegrated())
				this.userProfile.integrationsList.setPayPalIntegration(integrationStatus)
				isIntegrationSynced = true
				console.log("syncUserProfileIntegration: paypal trigger")
			}
			if (this.paymentIntegrationsData.isStripeIntegrated() !== this.userProfile.integrationsList.isStripeIntegrated()) {
				let integrationStatus = this.getIntegrationsStatusFromBoolean(this.paymentIntegrationsData.isStripeIntegrated())
				this.userProfile.integrationsList.setStripeIntegration(integrationStatus)
				isIntegrationSynced = true
				console.log("syncUserProfileIntegration: stripe trigger")
			}
			if (this.paymentIntegrationsData.isCloverIntegrated() !== this.userProfile.integrationsList.isCloverIntegrated()) {
				let integrationStatus = this.getIntegrationsStatusFromBoolean(this.paymentIntegrationsData.isCloverIntegrated())
				this.userProfile.integrationsList.setCloverIntegration(integrationStatus)
				isIntegrationSynced = true
				console.log("syncUserProfileIntegration: clover trigger")
			}
			if (isIntegrationSynced) {
				await this.$authManager.updateUserProfile(this.userProfile)
				// this.toast("Integration completed successfully.")
			}
		},


		animateForward() {
			this.transitionName = "slide"
		},
		animateBackward() {
			this.transitionName = "slideBack"
		},
		payPalConnectClicked() {
			if (this.isPayPalIntegrated) {
				let _ = this.$analyticManager.trackEvent("View PayPal integration", this.analyticsPropsMethod())
			} else {
				let _ = this.$analyticManager.trackEvent("Connect PayPal clicked", this.analyticsPropsMethod())
			}
			this.animateForward()
			this.paymentIntegrationItem = this.paymentIntegrationsData.payPalIntegration
			this.detailsView = this.payPalComponentName
		},


		async stripeConnectClicked() {
			if (this.isStripeIntegrated) {
				let _ = this.$analyticManager.trackEvent("View stripe integration", this.analyticsPropsMethod())
				this.animateForward()
				this.paymentIntegrationItem = this.paymentIntegrationsData.stripeIntegration
				this.detailsView = this.stripeComponentName
			} else {
				this.isStripeButtonLoading = true
				await this.startStripeConnectionFlow()
				this.isStripeButtonLoading = false
			}
		},

		async cloverConnectClicked() {
			if (this.isCloverIntegrated) {
				let _ = this.$analyticManager.trackEvent("View clover integration", this.analyticsPropsMethod())
				this.animateForward()
				this.paymentIntegrationItem = this.paymentIntegrationsData.cloverIntegration
				this.detailsView = this.cloverComponentName
			} else {
				this.isCloverButtonLoading = true
				await this.startCloverConnectionFlow()
				this.isCloverButtonLoading = false
			}
		},


		manualConnectClicked() {
			this.animateForward()

		},
		onDetailsBackClicked() {
			this.animateBackward()
			this.detailsView = null
		},
		onIntegrationSave(integrationItem) {
			this.paymentIntegrationsData.setIntegrationItem(integrationItem)
			this.paymentIntegrationsData.userId = this.ownerProfile.id

			this.progressBlocking("Saving the integration...")
				.for(_ => this.$dataManager.setPaymentIntegrations(this.paymentIntegrationsData))
				.then(_ => {

					this.toast("Integration completed successfully")
					this.onDetailsBackClicked()
				})
				.catch(error => this.handleError(error))

		},

		requestPaymentMethodClicked() {
			this.$analyticManager.trackEvent("Send request payment method email clicked", this.analyticsPropsMethod())
		},

		hasPaymentIntegrations() {
			return this.paymentIntegrationsData.hasIntegrations()
		},

		async enableCardPaymentsChanged(){
			let isEnabled = this.paymentIntegrationsData.isCardPaymentEnabled
			let action = isEnabled ? "enable" : "disable"
			let actionPast = isEnabled ? "enabled" : "disabled"
			let consequences = isEnabled ? "Your clients will be able to choose to pay you using their credit/debit card" : "Your clients won't be able to pay you using their credit/debit card"

			this.paymentIntegrationsData.isCardPaymentEnabled = !this.paymentIntegrationsData.isCardPaymentEnabled

			let res = await yesNoDialog({
				title: `Do you want to ${action} card payments?`,
				message: `All card payments will be ${actionPast}.<br/><br/>${consequences}`,
				yesTitle: "Confirm"
			})

			if(res){
				this.paymentIntegrationsData.isCardPaymentEnabled = !this.paymentIntegrationsData.isCardPaymentEnabled
				await this.savePaymentIntegrations()
			}
		},

		async enablePayPalPaymentsChanged(){
			let isEnabled = this.paymentIntegrationsData.isPayPalPaymentEnabled
			let action = isEnabled ? "enable" : "disable"
			let actionPast = isEnabled ? "enabled" : "disabled"
			let consequences = isEnabled ? "Your clients will be able to choose to pay you using their PayPal account" : "Your clients won't be able to pay you using their PayPal account"
			this.paymentIntegrationsData.isPayPalPaymentEnabled = !this.paymentIntegrationsData.isPayPalPaymentEnabled
			let res = await yesNoDialog({
				title: `Do you want to ${action} PayPal payments?`,
				message: `All PayPal payments will be ${actionPast}.<br/><br/>${consequences}`,
				yesTitle: "Confirm"
			})

			if(res){
				this.paymentIntegrationsData.isPayPalPaymentEnabled = !this.paymentIntegrationsData.isPayPalPaymentEnabled
				await this.savePaymentIntegrations()
			}
		},

		async onCreditCardMethodChanged(newValue, oldValue){
			console.log("onCreditCardMethodChanged: ", ...arguments)
			this.paymentIntegrationsData.creditCardMethod = oldValue
			let displayValue = newValue.toLowerCase()
			let res = await yesNoDialog({
				title: `Switch card payments to ${displayValue}?`,
				message: `All card payments will be switched to ${displayValue}.`,
				yesTitle: "Confirm"
			})

			if(res){
				this.paymentIntegrationsData.creditCardMethod = newValue
				await this.savePaymentIntegrations()
			}
			console.log("onCreditCardMethodChanged: ", ...arguments, ", this.paymentIntegrationsData.creditCardMethod = ", this.paymentIntegrationsData.creditCardMethod)
		},

		async savePaymentIntegrations(){
			await this.handleAsync([
				this.$dataManager.setPaymentIntegrations(this.paymentIntegrationsData),
				this.syncUserProfileIntegration()
			], "Saving...")
		},

		analyticsPropsInternal() {
			return {
				category: "Payment methods view"
			}
		}
	},

	computed: {
		isCardPaymentEnabled(){
			return this.paymentIntegrationsData.isCardPaymentEnabled
		},
		isPayPalPaymentEnabled(){
			return this.paymentIntegrationsData.isPayPalPaymentEnabled
		},

		isPayPalIntegrated() {
			let isPresent = this.paymentIntegrationsData && this.paymentIntegrationsData.payPalIntegration
			let res = isPresent ? this.paymentIntegrationsData.payPalIntegration.integrated() : false
			console.log("isPayPalIntegrated: isPresent = ", isPresent, ", res = ", res)
			return res
		},
		isStripeIntegrated() {
			let isPresent = this.paymentIntegrationsData && this.paymentIntegrationsData.stripeIntegration
			return isPresent ? this.paymentIntegrationsData.stripeIntegration.integrated() : false
		},
		isCloverIntegrated() {
			let isPresent = this.paymentIntegrationsData && this.paymentIntegrationsData.cloverIntegration
			return isPresent ? this.paymentIntegrationsData.cloverIntegration.integrated() : false
		},
		isCardPaymentIntegratedIgnoreDisabled() {
			let isPresent = this.paymentIntegrationsData
			return isPresent ? this.paymentIntegrationsData.isCardPaymentIntegratedIgnoreDisabled() : false
		}
	}
}
</script>

<style lang="scss">

.payment-methods-root{
	.el-radio__label{
		flex-basis: 0;
		flex-grow: 1;
		max-width: 100%;
	}
}
</style>
